import React, { useEffect, useState } from 'react';
import { Grid, Button, Card } from '@material-ui/core';
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import BuscadorAbm from '../../../compartidos/abms/BuscadorAbm';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import { makeStyles } from '@material-ui/core/styles';
import { BuscarInformesOftalmlogia, postProtocolosOftalmologia, putProtocolosOftalmologia, traerProtocolosOftalmologia } from '../../../../actions/hce/hceActions';
import AccionesGenericoAbm from '../../../compartidos/abms/AccionesGenericoAbm';
import { useDispatch, useSelector } from 'react-redux';
import { FormIngresoInformesOftalmo } from './FormIngresoInformesOftalmo';

const useStyles = makeStyles({
    botonera: {
      padding: 25,
    },
  });

export const HomeAbmInformeOftalmologia = () => {

    const dispatch = useDispatch();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [Informes, setInformes] = useState(false);
    const [openAlta, setOpenAlta] = useState(false);
    const { protocolosOftalmologia } = useSelector((state) => state.hce);
  
    useEffect(() => {
      dispatch(traerProtocolosOftalmologia());
    }, [dispatch]);
  
    const handleTiposSelectSelect = (item) => {
      setInformes(item);
      setOpen(true);
    };
  
    const handleSearch = (textoBuscado) => {
      dispatch(BuscarInformesOftalmlogia(textoBuscado));
    };
  
    const cerrarModalAlta = () => setOpenAlta(false);
  
    const cerrarModalModif = () => setOpen(false);
  
    const handleSave = (item) => {
      if (item.id) {
        dispatch(putProtocolosOftalmologia(item));
      } else {
        dispatch(postProtocolosOftalmologia(item));
      }
    };
  
    return (
      <div>
        <Grid container justify="center">
          <ModalAbm
            title="Agregar Protocolo"
            open={openAlta}
            setOpen={setOpenAlta}
          >
            <FormIngresoInformesOftalmo
              Informes={null}
              handleSave={handleSave}
              cerrarModal={cerrarModalAlta}
            />
          </ModalAbm>
          <ModalAbm title="Modificar Protocolo" open={open} setOpen={setOpen}>
            <FormIngresoInformesOftalmo
              Informes={Informes}
              handleSave={handleSave}
              cerrarModal={cerrarModalModif}
            />
          </ModalAbm>
          <Grid item xs={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenAlta(true)}
              style={{ float: 'right', marginTop: '1rem' }}
            >
              + Agregar Protocolo
            </Button>
          </Grid>
          <Grid item xs={12} md={6} className={classes.root}>
            <BuscadorAbm title="Buscar Informes" handleSearch={handleSearch} />
          </Grid>
          <Grid item xs={12} md={9} style={{ marginTop: '2rem' }}>
            <Card>
              <TableGeneric
                data={protocolosOftalmologia}
                columns={[
                  {
                    label: '',
                    customBody: (item) => (
                      <AccionesGenericoAbm
                        item={item}
                        handleItemSelect={handleTiposSelectSelect}
                        //permisoDelete={CONFIGURACION_CONTRATOS.BAJA}
                        //handleDelete={handleDelete}
                      />
                    ),
                  },
                  {
                    label: 'Nombre Informe',
                    id: 'nombreInforme',
                    sort: true,
                  },
                  {
                    label: 'Descripcion Informe',
                    id: 'descripcionInforme',
                    sort: true,
                  },
                ]}
              />
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  };
  